  document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 768) {
      const descriptions = document.querySelectorAll(".product-card-wrap .product-menu-box p"); // update selector if needed

      descriptions.forEach(function(desc) {
        const fullText = desc.innerText.trim();
        const previewLength = 70; // adjust based on desired preview size

        if (fullText.length <= previewLength) return; // skip short descriptions

        const previewText = fullText.slice(0, previewLength);
        const hiddenText = fullText.slice(previewLength);

        desc.innerHTML = `
          ${previewText}
          <span class="dots">... </span>
          <span class="more-text" style="display: none;">${hiddenText}</span>
          <button class="inline-read-more" style="background: none; color: #423931; border: none; cursor: pointer; padding: 0; font-size: 14px; 
          font-weight: 400;font-family: 'Gotham Cond'; text-transform: capitalize;letter-spacing: 0.7px;">Read More</button>
        `;

        const btn = desc.querySelector(".inline-read-more");
        const moreText = desc.querySelector(".more-text");
        const dots = desc.querySelector(".dots");

        btn.addEventListener("click", function () {
          const isExpanded = moreText.style.display === "inline";
          moreText.style.display = isExpanded ? "none" : "inline";
          dots.style.display = isExpanded ? "inline" : "none";
          btn.textContent = isExpanded ? "Read more" : " Read less";
        });
      });
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 768) {
      const descriptions = document.querySelectorAll(".product-card p"); // update selector if needed

      descriptions.forEach(function(desc) {
        const fullText = desc.innerText.trim();
        const previewLength = 40; // adjust based on desired preview size

        if (fullText.length <= previewLength) return; // skip short descriptions

        const previewText = fullText.slice(0, previewLength);
        const hiddenText = fullText.slice(previewLength);

        desc.innerHTML = `
          ${previewText}
          <span class="dots">... </span>
          <span class="more-text" style="display: none;">${hiddenText}</span>
          <button class="inline-read-more" style="background: none; color: #423931; border: none; cursor: pointer; padding: 0; font-size: 14px; 
          font-weight: 400;font-family: 'Gotham Cond'; text-transform: capitalize;letter-spacing: 0.7px;">Read More</button>
        `;

        const btn = desc.querySelector(".inline-read-more");
        const moreText = desc.querySelector(".more-text");
        const dots = desc.querySelector(".dots");

        btn.addEventListener("click", function () {
          const isExpanded = moreText.style.display === "inline";
          moreText.style.display = isExpanded ? "none" : "inline";
          dots.style.display = isExpanded ? "inline" : "none";
          btn.textContent = isExpanded ? "Read more" : " Read less";
        });
      });
    }
  });



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.see-options-wrapper').forEach(wrapper => {
    const btn = wrapper.querySelector('.see-options-btn');
    const details = wrapper.querySelector('.see-options-details');

    btn.addEventListener('click', function (event) {
      event.stopPropagation();
      const isVisible = details.style.display === 'block';
      // Hide all others first
      document.querySelectorAll('.see-options-details').forEach(el => el.style.display = 'none');
      // Then toggle current
      details.style.display = isVisible ? 'none' : 'block';
    });

    // Hide when clicking outside
    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        details.style.display = 'none';
      }
    });
  });
});

 document.addEventListener('DOMContentLoaded', function () {
    if (window.location.href.includes('gastro')) {
      document.body.classList.add('gastro');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.custom-data').forEach(function(el) {
      // Loop through child nodes
      el.childNodes.forEach(function(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          // Replace only in the plain text part
          node.textContent = node.textContent.replace(/gastro\s*/i, '').trimStart();
        }
      });

      // Also update data-value attribute if it exists
      if (el.hasAttribute('data-value')) {
        el.setAttribute(
          'data-value',
          el.getAttribute('data-value').replace(/gastro\s*/i, '').trim()
        );
      }
    });
    document.querySelectorAll('#menu-collection a').forEach(function(link) {
    // Update the text inside the link
    link.textContent = link.textContent.replace(/gastro-\s*/i, '').trimStart();

    // Update data-value if it exists
    if (link.hasAttribute('data-value')) {
      link.setAttribute(
        'data-value',
        link.getAttribute('data-value').replace(/gastro\s*/i, '').trim()
      );
    }
  });

  document.querySelectorAll('#collected-values-list a').forEach(function(link) {
    // Update the text inside the link
    link.textContent = link.textContent.replace(/gastro\s*/i, '').trimStart();

    // Update data-value if it exists
    if (link.hasAttribute('data-value')) {
      link.setAttribute(
        'data-value',
        link.getAttribute('data-value').replace(/gastro\s*/i, '').trim()
      );
    }
  });
  });

